import React, { Component } from 'react';

import './NossoAnoIniciativas.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import $ from 'jquery';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	estrategia_content
} from '../../settings';

import {
	TabButton,
	TabItem,
	HoveredImage,
	AccordionScrollableTitle
} from '../../components/';

class NossoAnoIniciativas extends Component {

	constructor() {
		super();

		this.$ = $;

        this.images = images;
        this.estrategia_content = estrategia_content;

        this.state = {
            width: window.innerWidth,
            tabsActive: null
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeTabs = this.changeTabs.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    changeTabs(i) {
    	console.log(i);
    	const { tabsActive } = this.state;
    	this.setState({
    		tabsActive: (tabsActive == i) ? null : i
    	});

    	let target = $('.accordion__item:nth-child('+ (i + 1) +')');
		setTimeout(function() {
			this.$("html, body").stop().animate({ scrollTop: target.offset().top }, 500, 'swing');
		}.bind(this), 100);
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('7.1 Iniciativas');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width, tabsActive } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'iniciativas'
		];

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>7.1 Principais iniciativas - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>7.1</span> Principais iniciativas</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Nosso ano</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column column--half">
				        			<Fade bottom>
				        				<h3 className="first_title">Nosso ano</h3>
				        				<p>Desenvolvemos iniciativas em linha com o plano de ação e com os compromissos assumidos com o mercado.</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--padding column--no-padding-mobile text-center">
				        			<Fade bottom>
					        			<HoveredImage
					        				image1={ this.images.iniciativas_img1 }
					        				image2={ this.images.iniciativas_img1_hover } />
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content destaques__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="blue_title">Veja alguns dos destaques de 2018:</h2>
				        			</Fade>
				        		</div>
		        			</div>
		        		</div>

		        		<div className="views__content destaques__view__content row">
			        		<div className="container">
				        		<div className="column">

				        			<Accordion onChange={ this.scrollItems }>

								        <AccordionItem className={ (tabsActive == 0 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 0)}>Agenda ANBIMA B3 de Mercado de Capitais</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>

								            	<p>São inúmeros os benefícios socioeconômicos que o fortalecimento do mercado de capitais pode trazer para o Brasil. Para dimensionar esses ganhos, elaboramos um estudo, em parceria com a B3, mostrando como o crescimento do mercado impactaria os principais indicadores econômicos até 2022. Os resultados apontam:</p>

					        					<div className="highlight_numbers row">
													<div className="highlight_numbers__number">
														<h4 className="first_text">11,7</h4>
														<h5 className="second_text">milhões</h5>
														<h5 className="third_text">de novos empregos</h5>
													</div>
													<div className="highlight_numbers__number">
														<h5 className="third_text">Crescimento de</h5>
														<h4 className="first_text">12,1%</h4>
														<h5 className="second_text">do PIB</h5>
													</div>
													<div className="highlight_numbers__number">
														<h5 className="third_text">Taxa de investimento</h5>
														<h4 className="first_text">R$ 294</h4>
														<h5 className="second_text">bilhões</h5>
														<h5 className="third_text">superior à projetada<br />para o mesmo período</h5>
													</div>
													<div className="highlight_numbers__number">
														<h5 className="third_text">Arrecadação de impostos de</h5>
														<h4 className="first_text">R$ 2,4</h4>
														<h5 className="second_text">trilhões</h5>
														<h5 className="third_text">em cinco anos</h5>
													</div>
												</div>

								            	<p>O estudo inclui uma agenda, com medidas de caráter microeconômico, com ajustes regulatórios e institucionais, que têm potencial para acelerar a expansão dos mecanismos privados de mobilização e alocação de poupança.<br /><br />A Agenda ANBIMA B3 para o Desenvolvimento do Mercado de Capitais gira em torno de cinco grandes objetivos:</p>

								            	<ul>
									            	<li>Fomentar o financiamento de longo prazo;</li>
													<li>Ampliar o volume de emissões;</li>
													<li>Diversificar a base de investidores;</li>
													<li>Aumentar a liquidez;</li>
													<li>Estimular a formação de poupança.</li>
								            	</ul>

								            	<p>Para cada item, há um conjunto de iniciativas, que envolvem mudanças regulatórias ou legais; medidas de estímulo à transparência e a maior troca de informações; e ações de fomento à educação.</p>

								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 1 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 1)}>ANBIMA Data</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>
									            	Reunir informações de produtos financeiros em um único lugar, desde o registro do papel até o preço atual. Foi com esse propósito que o ANBIMA Data nasceu em novembro. De fácil navegação, a plataforma contribui para dar mais transparência, fomentando os negócios no mercado secundário e oferecendo mais informações comparáveis e de qualidade aos investidores.
													<br /><br />
													O ANBIMA Data traz, por enquanto, informações de debêntures – os dados incluem registro, taxas, preço unitário, passando por todos os documentos da oferta e pelos eventos corporativos que afetam o valor do papel, como amortização ou liquidação, entre outros.
												</p>

				        						<h3 className="blue_title">O que esperar para 2019:</h3>
												<p>O ANBIMA Data incluirá informações de dois outros produtos: CRIs (Certificados de Recebíveis Imobiliários) e CRAs (Certificados de Recebíveis do Agronegócio). </p>
								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 2 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 2)}>Certificações e educação continuada</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
				        						<h3 className="blue_title">Certificações</h3>
												<p>Mais de 46 mil certificações foram emitidas em 2018, 5,4% de crescimento na comparação com 2017. A CEA (Certificação de Especialista ANBIMA), voltada aos profissionais que assessoram os gerentes de conta de clientes pessoas físicas, foi a que mais cresceu no ano, com aumento de 33,3%. A CPA-10 (Certificação Profissional ANBIMA – Série 10), destinada a profissionais da rede de agências bancárias e plataformas de atendimento, mantém-se como a qualificação mais procurada pelos certificados, seguida pela CPA-20 (Certificação Profissional ANBIMA – Série 20), voltada para a comercialização de produtos nos segmentos varejo alta renda, private, corporate e investidores institucionais.</p>
												
												<img src={ this.images.iniciativas_map1 } />
												
												<p>A atualização da CPA-10 e da CPA-20 – que acontece a cada cinco anos – passou a ocorrer exclusivamente por meio de curso, seja da ANBIMA ou oferecido pela instituição na qual o profissional trabalha. Antes era necessário fazer uma prova online, o que foi excluído.</p>

				        						<h3 className="blue_title">Educação continuada</h3>
				        						<p>No ano, mais de 6 mil alunos realizaram os 16 cursos online e 27 presenciais da nossa grade de educação continuada, que cobre temas de interesse dos profissionais dos mercados financeiro e de capitais. O número é 34% maior do que o registrado em 2017. <br /><br />Um dos destaques foi o lançamento do Curso de Serviços Qualificados, voltado para profissionais que trabalham com custódia, controladoria, escrituração e representação de investidores não residentes. Aqueles que concluírem as aulas online podem obter a certificação PQO (Programa de Qualificação Profissional – Custódia) da B3 sem a necessidade de realizar uma prova. <br /><br />Presencialmente, foram oferecidos cursos em 19 temas, sempre em parceria com a CNF (Confederação Nacional das Instituições Financeiras), além da realização de 11 cursos in company (personalizado de acordo com os objetivos do cliente). Os cursos de atualização das certificações CPA-10 e CPA-20 também tiveram aumento na procura de 30% e 47%, respectivamente.</p>

				        						<h3 className="blue_title">Diversidade</h3>
				        						<p>Aderimos ao projeto da Febraban que oferece cursos para auxiliar na capacitação de jovens negros para o mercado financeiro, contribuindo para a construção do programa e das aulas. Também é oferecida isenção da taxa de inscrição do exame da CPA-10 aos alunos que forem aprovados no programa.</p>
								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 3 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 3)}>Pesquisa Raio X do Investidor Brasileiro</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>Estudo realizado em parceria com o Datafolha traçou o perfil do investidor brasileiro, identificou as preferências de investimento da população, suas motivações para aplicar e como ela enxerga o futuro, entre outros aspectos.</p>

				        						<h3 className="blue_title">Como a pesquisa foi feita?</h3>

								            	<ul>
									            	<li>3.374 pessoas;</li>
													<li>Com mais de 16 anos;</li>
													<li>De 152 municípios;</li>
													<li>Das classes A, B e C;</li>
													<li>Economicamente ativas, que vivem de renda ou aposentadas.</li>
								            	</ul>

				        						<h3 className="blue_title">Principais achados</h3>

								            	<p>A pesquisa, que será feita anualmente, mostra que mais da metade dos brasileiros não conhece e não utiliza produtos de investimento. Efetivamente, 42% das pessoas declararam em 2017 que tinham aplicações em produtos de investimento.</p>

				        						<h3>O levantamento também indicou que:</h3>

					        					<div className="highlight_numbers row">
													<div className="highlight_numbers__number">
														<h4 className="first_text">32%</h4>
														<h5 className="second_text">das pessoas</h5>
														<h5 className="third_text">conseguiram guardar<br />dinheiro em 2017.</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">41%</h4>
														<h5 className="second_text">das pessoas</h5>
														<h5 className="third_text">buscam informações<br />sobre aplicações presencialmente<br />com o gerente do banco.</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">51%</h4>
														<h5 className="second_text">das pessoas</h5>
														<h5 className="third_text">desejavam fazer<br />alguma aplicação em 2018.</h5>
													</div>
												</div>

												<div className="link_nosso_site">
													<img src={ this.images.ico_site } />
													<span>Saiba mais sobre a pesquisa no <a href="http://www.anbima.com.br/pt_br/especial/raio-x-do-investidor-2018.htm" target="_blank">nosso site</a></span>
												</div>

								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 4 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 4)}>Cursos educativos de autorregulação</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>Lançado em maio, o MAP (Módulo de Aprendizagem e Publicações) é uma plataforma com conteúdo educativo sobre as atividades de autorregulação. O conteúdo online está integrado ao SSM (Sistema de Supervisão de Mercados), utilizado na troca de informações entre a ANBIMA e as instituições que seguem as regras de autorregulação.</p>

				        						<h3 className="blue_title">Em 2018, foram disponibilizados quatro cursos gratuitos:</h3>

								            	<ul>
									            	<li>Introdução à autorregulação;</li>
													<li>Administração fiduciária;</li>
													<li>Gestão de recursos;</li>
													<li>Distribuição de fundos pelo próprio gestor.</li>
								            	</ul>

								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 5 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 5)}>Base de distribuidores de fundos</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>Criação de base de dados inédita com informações das instituições que distribuem fundos de investimento. A iniciativa nasceu a partir da Instrução CVM 558, que permitiu que os gestores comercializassem seus próprios fundos. A novidade abre caminho para a produção de novos relatórios, rankings e estatísticas que poderão enriquecer o conjunto de informações disponíveis sobre o setor.</p>
								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 6 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 6)}>Convênios com a CVM</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>
								            		As parcerias com a CVM fortalecem o papel da Associação como representante do mercado e  ajudam a potencializar ganhos entre a regulação
													e a autorregulação. O destaque do ano foi o novo convênio de supervisão de fundos.
													<br /><br />
													Desde de setembro, a parceria permite que a ANBIMA faça a análise prévia dos pedidos de autorização para administradores de carteiras mobiliárias feitos à CVM. A documentação passou a ser enviada pelo SSM (Sistema de Supervisão de Mercados), plataforma de interação
													com as instituições que seguem a autorregulação. As empresas podem solicitar, simultaneamente, adesão aos códigos de autorregulação.
													O convênio incluiu, ainda, a troca de informações sobre a supervisão de precificação e de distribuição de cotas de fundos, iniciada em 2019.
													<br /><br />
													Além disso, foi ampliado o convênio para análise prévia de ofertas públicas, que passou a incluir análise de pedidos de emissões de cotas de FIPs (Fundos de Investimento em Participação) e de FIDCs (Fundos de Investimento em Direitos Creditórios) – exceto os não padronizados e aqueles enquadrados na tributação prevista na Lei 12.431 – e a maioria dos lastros de CRIs (Certificados de Recebíveis Imobiliários). 
												</p>
								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 7 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 7)}>Mudanças na autorregulação</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>A publicação de dois novos códigos em maio de 2018 – que entraram em vigor em 2 de janeiro de 2019 – foi um marco para a autorregulação.</p>

								            	<ul>
									            	<li>O Código de Distribuição substitui os códigos de Varejo e de Private Banking;</li>
													<li>O Código de Administração de Recursos de Terceiros entra no lugar dos códigos de Fundos e de Gestão de Patrimônio.</li>
								            	</ul>

								            	<p>As regras da autorregulação, que antes eram voltadas para os produtos, passam a focar nas atividades e na conduta dos profissionais do mercado, deixando mais claras as responsabilidades de cada um dos agentes.</p>
								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 8 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 8)}>Nova lei do ISS</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>
								            	No primeiro trimestre de 2018, atuamos, junto com a CNF (Confederação Nacional das Instituições Financeiras), na articulação da reforma
												do ISS (Imposto sobre Serviços de qualquer natureza).
												<br /><br />
												A Lei Complementar 157, que alterou a legislação do ISS para determinados serviços – entre eles o de administração de fundos de investimento –, transferiu a cobrança do imposto do município do prestador (que é o administrador, no caso da indústria de fundos) para o do tomador
												de determinados serviços (cotista). O objetivo é aumentar a arrecadação fiscal nas cidades. A mudança impactou o segmento de fundos, aumentando os custos operacionais e trazendo insegurança jurídica.
												<br /><br />
												Para diminuir esses impactos, o trabalho da Associação focou em três frentes: legislativa, jurídica e operacional. Mais informações podem ser acessadas nesta <a href="http://www.anbima.com.br/pt_br/especial/nova-lei-do-iss.htm" target="_blank">página especial.</a>
												</p>
								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 9 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 9)}>Aumento no número de ativos precificados</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>
								            	Temos uma base robusta de precificação de títulos públicos e privados. A divulgação de taxas médias e preços unitários tem o objetivo
												de dar transparência e fomentar as negociações no mercado secundário.
												<br /><br />
												Em 2018, aumentamos em 10% o número desses papéis na precificação, correspondendo a 312 ativos no fim de 2018. Com relação
												às inclusões, estrearam 97 novos ativos na nossa base. 
												<br /><br />
												Considerando as negociações realizadas no mercado secundário, os ativos precificados representaram 91% das operações realizadas.
												</p>
								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 10 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 10)}>Reforço na atuação internacional</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>
								            	Acompanhamos as pautas do mercado ao redor do mundo e valorizamos a troca de informações em uma série de debates internacionais que tratam de assuntos como regulação, educação e autorregulação.
								            	<br /><br />
								            	Para acompanhamento da regulação internacional ainda mais de perto, está em desenvolvimento uma ferramenta que permitirá o envio de comunicado diário sobre as alterações nas regras dos Estados Unidos, da União Europeia e do Reino Unido.
												</p>

				        						<h3 className="blue_title">Veja as nossas participações em eventos internacionais de 2018:</h3>

				        						<div className="timeline_list">
					        						<h3 className="blue_title">FEVEREIRO</h3>
					        						<p>
					        							<strong>Reuniões do board da Iosco (Madri, Espanha; e Budapeste, Hungria): </strong><br />
					        							Participação nas duas primeiras reuniões do ano da diretoria da Iosco (Organização Internacional das Comissões de Valores Mobiliários), entidade que reúne os reguladores de todo o mundo. Os debates envolveram os desafios dos reguladores em assuntos como cibersegurança, ICOs (Ofertas Iniciais de Moedas), conduta na distribuição de produtos entre países e gestão passiva. O evento de maio aconteceu durante a 43ª Conferência Anual da Iosco, que contou também com uma reunião do AMCC (Comitê Consultivo de Membros Afiliados), grupo da Iosco que discute autorregulação. 
					        						</p>

					        						<h3 className="blue_title">MARÇO</h3>
					        						<p>
					        							<strong>IX Encontro de Supervisores da Aliança do Pacífico (Cidade do México, México): </strong><br />
					        							Discussão de temas como tributação, regulação, passaporte de fundos, aumento da demanda por investimentos no exterior e maior disponibilização de informações aos investidores.
					        						</p>

					        						<h3 className="blue_title">ABRIL</h3>
					        						<p>
					        							<strong>10ª Conferência Global de Educação de Investidores (Tóquio, Japão): </strong><br />
					        							Debate sobre iniciativas que facilitem a tomada de decisão do investidor. Apresentamos a pesquisa sobre a relação do brasileiro com o dinheiro.
					        							<br /><br />
					        							<strong>Encontro semestral do SMPG (Varsóvia, Polônia): </strong><br />
					        							Apresentação no SMPG (Securities Market Practice Group) sobre padronização na troca de mensageria ISO para investimentos, envolvendo discussões relacionadas ao mercado de fundos. 
					        						</p>

					        						<h3 className="blue_title">MAIO/JUNHO</h3>
					        						<p>
					        							<strong>50ª Conferência da ICMA (Madri, Espanha): </strong><br />
					        							Reunião anual da ICMA (Associação Internacional de Mercado de Capitais), da qual somos membros. O encontro discutiu títulos verdes e digitalização.
					        						</p>

					        						<h3 className="blue_title">AGOSTO</h3>
					        						<p>
					        							<strong>XVI Convenção Anual da Indústria de Fundos Mútuos (Santiago, Chile): </strong><br />
					        							Apresentação de iniciativas em inovação e cibersegurança.
					        						</p>

					        						<h3 className="blue_title">SETEMBRO</h3>
					        						<p>
					        							<strong>27ª Conferência Global de Distribuição da Alfi (Luxemburgo): </strong><br />
					        							Evento da Alfi (Associação da Indústria de Fundos de Luxemburgo) debateu temas como a criação de um passaporte regional de fundos para facilitar a distribuição do produto na América Latina, impactos das novas tecnologias e formas de simplificar a distribuição de produtos financeiros.
					        							<br /><br />

					        							<strong>Assembleia Anual da FiaFin (Santo Domingo, República Dominicana): </strong><br />
					        							Evento da FiaFin (Federação Iberoamericana de Fundos de Investimento). José Carlos Doherty, nosso superintendente-geral, foi reeleito diretor da entidade por mais dois anos.
					        							<br /><br />

					        							<strong>Reunião Iarc e Cosra (Ilhas Cayman): </strong><br />
					        							Conferência do Iarc (Comitê Regional Interamericano da Iosco), que discutiu implicações das criptomoedas, investimento em países emergentes e oportunidades e desafios para se construir um mercado de capitais sustentável. Participação como observadores da reunião do Cosra (Conselho de Reguladores de Valores Mobiliários das Américas), que tratou de temas como inovação, sustentabilidade e integração regional.
					        							<br /><br />

					        							<strong>Jornadas sobre proteção do investidor (Montevidéu, Uruguai): </strong><br />
					        							Apresentação sobre o modelo de autorregulação e de supervisão da ANBIMA, sua adequação às regras de publicidade e seu papel na qualificação dos profissionais do mercado.
					        						</p>

					        						<h3 className="blue_title">OUTUBRO</h3>
				        						</div>
				        						<p>
				        							<strong>Reunião Semestral do AMCC (Londres, Inglaterra): </strong><br />
				        							Debate sobre as contribuições do Comitê Consultivo de Membros Afiliados ao trabalho da Iosco em temas como identificação de riscos emergentes, contratação de terceiros, cibersegurança e mudanças na regulação de derivativos. Coordenação de um painel sobre alavancagem na indústria de fundos e ETFs (Exchange Traded Funds).
													<br /><br />

				        							<strong>32ª conferência da IIFA (Pequim, China): </strong><br />
				        							Apresentação sobre as características da regulação e da autorregulação da indústria brasileira de fundos – como as mudanças na regulação decorrentes das Instruções 555 e 558 da CVM –, em evento da IIFA (Associação Internacional de Fundos de Investimento). José Carlos Doherty, nosso superintendente-geral, foi reeleito diretor da associação pelos próximos dois anos e assumiu o comando do grupo de trabalho que discute a regulação da indústria de fundos.
				        							<br /><br />

				        							<strong>Conferência anual da Sifma (Washington DC, Estados Unidos): </strong><br />
				        							Evento da associação que reúne instituições, bancos de investimentos e gestores do mercado de capitais americano. Foram debatidas mudanças nos mercados de derivativos e a transformação da indústria de investimentos com as inovações tecnológicas.
				        							<br /><br />

				        							<strong>Edufin Summit (Buenos Aires, Argentina): </strong><br />
				        							Participação em mesa-redonda sobre os impactos da transformação digital na educação financeira. Organizado pelo BBVA (Banco Bilbao Vizcaya Argentaria), o encontro abordou a relação das finanças com igualdade de gêneros, mudanças climáticas, pobreza, juventude e longevidade.
				        						</p>

								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 11 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 11)}>Balanço da supervisão</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<p>
									            	Cento e doze instituições do mercado passaram a seguir as regras dos códigos de autorregulação em 2018.
									            	<br /><br />
									            	A área Supervisão de Mercados verifica o cumprimento das exigências descritas nos códigos. O trabalho é contínuo e prioritariamente educativo, ou seja, o primeiro passo após a identificação de um descumprimento é o envio de uma carta de orientação. Situações reincidentes ou muito graves levam a punições e, caso haja recursos arrecadados, estes são destinados a iniciativas de educação financeira.
												</p>

												<h3>O ano somou:</h3>

					        					<div className="highlight_numbers row">
													<div className="highlight_numbers__number">
														<h4 className="first_text">2.016</h4>
														<h5 className="second_text">pedidos</h5>
														<h5 className="third_text">de esclarecimento</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">546</h4>
														<h5 className="second_text">cartas de<br />orientação</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">1</h4>
														<h5 className="second_text">carta de<br />recomendação</h5>
													</div>
													<div className="highlight_numbers__number">
														<h5 className="third_text">Abertura de</h5>
														<h4 className="first_text">13</h4>
														<h5 className="second_text">PAIs</h5>
														<h5 className="third_text">(Procedimentos<br />para Apuração<br />de Irregularidades)</h5>
													</div>
												</div>

					        					<div className="highlight_numbers row">
													<div className="highlight_numbers__number">
														<h4 className="first_text">659</h4>
														<h5 className="second_text">multas</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">6</h4>
														<h5 className="second_text">processos</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">7</h4>
														<h5 className="second_text">julgamentos</h5>
													</div>
													<div className="highlight_numbers__number">
														<h4 className="first_text">14</h4>
														<h5 className="second_text">termos<br/>de compromisso</h5>
														<h5 className="third_text">assinados</h5>
													</div>
												</div>

												<br /><br />
												<h3 className="blue_title">Sendo que:</h3>
												<br />

								            	<ul>
								            		<li>A maioria das multas refere-se às exigências dos códigos de Fundos de Investimento, de FIP/FIEE (Fundos de Investimento em Participação/Fundos de Investimento em Empresas Emergentes) e de Ofertas Públicas. Os motivos são atrasos ou erros no envio de informações para a base de dados;</li>
								            	</ul>
								            	<ul>
								            		<li>Todos os julgamentos realizados em 2018 são referentes a fundos de investimento, sendo seis deles do Código dos Fundos (produtos regulados pela Instrução CVM 555) e um do Código FIP/FIEE. A maioria dos fundos julgados tinham RPPSs (Regimes Próprios de Previdência Social) como cotistas;</li>
								            	</ul>
								            	<ul>
								            		<li>O número de pedidos de esclarecimento cresceu 230% em relação a 2017.</li>
								            	</ul>

								            </AccordionItemBody>
								        </AccordionItem>

								        <AccordionItem className={ (tabsActive == 12 || tabsActive == null) ? 'accordion__item accordion__item--active' : 'accordion__item' }>
								            <AccordionItemTitle>
								                <h3 onClick={this.changeTabs.bind(null, 12)}>Selic</h3>
								            </AccordionItemTitle>
								            <AccordionItemBody>
								            	<img src={ this.images.selic } />
								            	<p>
									            	O convênio da ANBIMA com o Banco Central para cooperação operacional do Selic (Sistema Especial de Liquidação e de Custódia) foi renovado em dezembro de 2018 por mais cinco anos – existe desde 1974. 
									            	<br /><br />
													Responsável por processar a emissão, o resgate, o pagamento de juros e a custódia dos títulos que fazem parte da dívida pública, o Selic também calcula a taxa Selic diária com base nas operações de financiamento. Com 99,99% de disponibilidade em 2018, o sistema processou 594 leilões de títulos públicos (volume 49% maior que no ano anterior), e realizou cerca de 21,3 mil operações diárias.
													<br /><br />
													Para manter a excelência na disponibilidade, novos investimentos estão planejados para 2019: os mainframes serão substituídos por mais modernos e, além dos dois datacenters do Rio de Janeiro, em prédio distintos, será criado um terceiro datacenter em Brasília.
												</p>
												<h3 className="blue_title">Outros destaques do ano foram:</h3>
												<p>
													<strong>Extrato para o cliente final de títulos públicos</strong><br />
													Principal iniciativa no ano, a disponibilização pela internet dos extratos para os investidores pessoas físicas e jurídicas que têm títulos públicos (exceto Tesouro Direto) trouxe mais transparência e praticidade para mais de 139 mil clientes, que é o universo de pessoas com contas
													no Selic. Lançada em maio, a novidade eliminou a necessidade de um intermediário (banco ou corretora) para a consulta dos títulos.
													Antes, apenas as instituições financeiras participantes do Selic, isto é, bancos ou corretoras em que as pessoas têm conta, tinham acesso ao extrato.
												</p>
												<p>
													<strong>Simplificação para transferência de investidores não residentes</strong><br />
													Para tornar as operações mais dinâmicas e atender uma demanda do mercado, o Selic passou a permitir que clientes não residentes que possuam o mesmo código CVM transfiram títulos entre suas contas em diferentes instituições. Quando é cadastrado na Receita Federal, o investidor não residente recebe uma identificação de cada instituição, mas mantém o mesmo código na CVM.
												</p>
												<p>
													<strong>Cibersegurança</strong><br />
													Foi iniciado o programa de três anos chamado Resiliência Cibernética, visando a um ambiente digital mais seguro. O projeto conta com atualização de softwares e melhoria de processos. Será criada ainda uma área para monitorar e tratar eventos de segurança de maneira mais estruturada, o Security Operation Center.
												</p>
								            </AccordionItemBody>
								        </AccordionItem>

								    </Accordion>

				        		</div>
		        			</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { NossoAnoIniciativas };
